import { render, staticRenderFns } from "./UserHome.vue?vue&type=template&id=355cf702&scoped=true&"
import script from "./UserHome.vue?vue&type=script&lang=js&"
export * from "./UserHome.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "355cf702",
  null
  
)

export default component.exports